import { Widget } from '@kinetic-ui/data-layer';
import React from 'react';
import { CameraDetailsOverlayProps } from './types';
import CameraOverlay from './CameraOverlay';
import WidgetOverlay from './WidgetOverlay';
import { VideoPlayerCamera } from 'types/videoPlayerTypes';

const CameraDetailsOverlay: React.FunctionComponent<CameraDetailsOverlayProps> = (props) => {
  const { data } = props;

  const { removeFromLayout, goFullScreen, exitFullScreen, hideWhenDragged } = props;
  const widgetProps = { removeFromLayout, goFullScreen, exitFullScreen, hideWhenDragged };

  const isCamera = (model: Widget | VideoPlayerCamera): model is VideoPlayerCamera => {
    return !!(model as VideoPlayerCamera).streams;
  };

  const renderCameraDetailsOverlay = () => {
    if (isCamera(data)) {
      return <CameraOverlay {...props} data={data} />;
    }
    return <WidgetOverlay {...widgetProps} data={data as Widget} />;
  };

  return renderCameraDetailsOverlay();
};

export default CameraDetailsOverlay;
